import { Paper, Box, CircularProgress } from "@mui/material";
import React, { useRef, useEffect, useState } from 'react';
import moment from "moment";
import { useParams } from "react-router-dom";
import * as alarmeService from "../services/alarmeService";
import { useDispatch } from "react-redux";
import { Col, Row, Container } from "react-bootstrap"
import * as trackerService from "../services/trackerService";
import * as usinaService from "../services/usinaService";
import * as getFeatures from "../services/featuresService";
import CircleIcon from '@mui/icons-material/Circle';
import MapTwoToneIcon from '@mui/icons-material/MapTwoTone';

export default function TrackerMap() {
    const [energiaMedidor, setEnergiaMedidor] = useState([]);
    const [totalizadores, setTotalizadores] = useState({});
    const date = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
    };
    const { usinaId } = useParams();
    const iframeRef = useRef(null);
    const [html, setHtmlContent] = useState()
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const filters = {
        nome: "",
        usina: usinaId,
        tipo_equipamento: "tracker",
        status: "ativo",
        data_inicio: null,
        data_fim: null,
    };

    async function getData() {
        const features = await getFeatures.getFeatures(usinaId);
        const trackerMapFeature = features.find(f => f.feature === "TrackersMap");
        const trackerMapUrl = trackerMapFeature?.attachmentUrl;
        if (trackerMapUrl) {
            const response = await fetch(trackerMapUrl);
            const data = await response.text();
            setHtmlContent(data);
        }

        const alarmes = await alarmeService.getAllAlarmsWithoutPagination({
            filters: filters,
            currentPage: 0,
            itemsPerPage: 100
        });


        return alarmes.alarmes
    }

    async function updatePage() {
        const alarmes = await getData()
        const trackers = await trackerService.buscarUltimosRegistrosTrackers(usinaId);

        processarResposta(alarmes, trackers);
    }

    useEffect(async () => {
        setLoading(true);

        let intervaloDTO = {
            startDate: "",
            endDate: "",
        };

        intervaloDTO.startDate = moment(
            new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0)
        ).format("YYYY-MM-DDTHH:mm");

        intervaloDTO.endDate = moment(
            new Date(date.year, date.month - 1, date.day, 23, 59, 59)
        ).format("YYYY-MM-DDTHH:mm");

        const [energiaMedidorData, totalizadorData] =
            await Promise.all([
                usinaService.getEnergiaMedidor({ usinaId, intervaloDTO }),
                usinaService.getUsinaTotalizador(usinaId)
            ]);
        setTotalizadores(totalizadorData);
        setEnergiaMedidor(energiaMedidorData);

        const alarmes = await getData()
        const trackers = await trackerService.buscarUltimosRegistrosTrackers(usinaId);

        setLoading(false);

        processarResposta(alarmes, trackers);

        let counter = 0;

        const intervalId = setInterval(() => {
            counter++;
            if (counter === 60) {
                updatePage();
                counter = 0;
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    function setTrackerFault(cod, description, element) {

        element.style.fill = "#ff0000";
        element.classList.add('vermelho');
        element.setAttribute('title', `Tracker ${cod}`);

        // Adiciona o evento de mouseover para exibir o título
        element.addEventListener('mouseover', () => {
            const tooltip = document.createElement('div');
            tooltip.textContent = `Tracker ${cod} - ${description}`;
            tooltip.style.position = 'absolute';
            tooltip.style.backgroundColor = 'white';
            tooltip.style.border = '1px solid black';
            tooltip.style.padding = '5px';
            tooltip.style.zIndex = '1000';

            const rect = element.getBoundingClientRect();
            tooltip.style.left = `${rect.left}px`;
            tooltip.style.top = `${rect.bottom + 5}px`;

            document.body.appendChild(tooltip);

            element.addEventListener('mouseout', () => {
                document.body.removeChild(tooltip);
            }, { once: true });
        });
    }

    // Função para processar a resposta e adicionar classes
    async function processarResposta(alarmes, trackers) {
        alarmes.forEach(alarme => {
            if (
                alarme?.tracker?.cod &&
                alarme?.alarmeTipo?.descricao != "Sobrecorrente na saída 24V"
            ) {
                const elemento = document.getElementById(`trk-${String(alarme.tracker.cod).padStart(2, "0")}`);
                if (elemento) {
                    setTrackerFault(alarme.tracker.cod, alarme?.alarmeTipo?.descricao, elemento)
                }
            }
        });

        trackers.forEach(tracker => {
            if (tracker?.status == 0) {
                const elemento = document.getElementById(`trk-${String(tracker?.cod).padStart(2, "0")}`);
                if (elemento) {
                    setTrackerFault(tracker?.cod, "FALHA", elemento)
                }
            }
        });
    }


    let trackerMap = (
        <>
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "75vh",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : (<>
                <Paper elevation={3}
                >
                    <Container>
                        <Row
                            className="mb-3 justify-content-center align-items-center"
                            style={{ fontFamily: 'Roboto' }}
                        >
                            <Col
                                xs={12} md={6}
                                className="pt-2 pb-sm-2  d-flex flex-column align-items-start justify-content-center"
                            >
                                <div className="d-flex align-items-center">
                                    <MapTwoToneIcon sx={{ color: "#4e596b" }} />
                                    <b style={{ fontSize: "20px", marginLeft: 8, color: "#4e596b" }}>
                                        Topologia dos Trackers
                                    </b>
                                </div>
                            </Col>
                            <Col
                                xs={12} md={6}
                                className="pt-2 pb-sm-2 d-flex flex-column align-items-end justify-content-center"

                            >
                                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                                    <b className="" style={{ color: "#4e596b" }}>
                                        <CircleIcon sx={{ color: "red" }} /> Inativo
                                    </b>
                                    <b className="" style={{ color: "#4e596b" }}>
                                        <CircleIcon sx={{ color: "green" }} /> Ativo
                                    </b>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Paper>

                <Paper
                    style={{ minHeight: "90vh", padding: "15px" }} elevation={3}
                >
                    <Container className="d-flex justify-content-center">
                        <div
                            className="d-flex justify-content-center align-items-center text-center"

                            dangerouslySetInnerHTML={{ __html: html }}

                            style={{ width: "100%", fontFamily: 'Roboto', color: "#4e596b" }}
                        />
                    </Container>
                </Paper>
            </>)
            }
        </>
    )

    return trackerMap

}